import React from 'react';
import { Box, TextField, Button, MenuItem, Link } from '@mui/material';
import BaseCodeSelectbox from '../selectbox/BaseCodeSelectbox';
import MobileSearchAdornment from '../../../common/search/MobileSearchAdornment';

export const PartnerListBox = ({ formik, link }) => {
  return (
    <div>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          alignItems: 'center',
          my: 1,
        }}
      >
        <Box
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            flexGrow: 1,
            display: { xs: 'contents', sm: 'flex' },
            flexDirection: 'row',
            flexWrap: { xs: 'wrap', sm: 'nowrap' },
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
            alignItems: 'center',
            rowGap: 1,
            mr: 2,
          }}
          onSubmit={formik.handleSubmit}
        >
          <Box
            sx={{
              order: { xs: 2, sm: 0 },
              flexBasis: { xs: '100%', sm: 'auto' },
              flex: { xs: '1 1 100%', sm: '0 1 auto' },
              minWidth: 0,
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'nowrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              '& > :not(style)': { m: { xs: 0.5, sm: 1 }, width: { sm: '25ch' } },
              '& > :first-of-type': { flex: { xs: '0 0 38%', sm: '0 1 auto' } },
              '& > :last-of-type': { flex: { xs: 1, sm: '0 1 auto' } },
            }}
          >
            <TextField
              variant="standard"
              required
              select
              id="searchKeyword"
              name="searchKeyword"
              label="검색키워드"
              value={formik.values.searchKeyword}
              onChange={formik.handleChange}
              error={
                formik.touched.searchKeyword &&
                Boolean(formik.errors.searchKeyword)
              }
              helperText={
                formik.touched.searchKeyword && formik.errors.searchKeyword
              }
            >
              <MenuItem value="partnerNm">회사명</MenuItem>
              <MenuItem value="regNumber">사업자번호</MenuItem>
              <MenuItem value="partnerPhone">연락처</MenuItem>
            </TextField>
            <TextField
              variant="standard"
              required
              id="searchWords"
              name="searchWords"
              label="검색어"
              onChange={formik.handleChange}
              error={
                formik.touched.searchWords && Boolean(formik.errors.searchWords)
              }
              helperText={
                formik.touched.searchWords && formik.errors.searchWords
              }
              InputProps={{
                endAdornment: <MobileSearchAdornment disabled={formik.isSubmitting} />,
              }}
            />
          </Box>
          <Box
            sx={{
              order: { xs: 1, sm: 0 },
              flexBasis: { xs: '100%', sm: 'auto' },
              '& > :not(style)': { m: { xs: 0.5, sm: 1 }, width: { xs: '60%', sm: '25ch' } },
            }}
          >
            <BaseCodeSelectbox
              formik={formik}
              label="거래처 종류"
              variant="standard"
              required={false}
              fullWidth
              filterObject={{
                blcCd: 'BASE',
                mlcCd: 'PARTNER',
                slcCd: 'PARTNER_TYP',
                useYn: 'Y',
              }}
              name="searchPartnerTyp"
              size="small"
            />
          </Box>

          <Box sx={{ order: { xs: 3, sm: 0 }, display: { xs: 'none', sm: 'block' } }}>
            <Button
              type="submit"
              color="info"
              variant="contained"
              disabled={formik.isSubmitting}
            >
              검색
            </Button>
          </Box>
          {link && (
            <Box sx={{ order: { xs: 3, sm: 0 }, mx: { xs: 0, sm: 2 }, display: { xs: 'none', sm: 'block' } }}>
              <Button
                component={Link}
                color="warning"
                variant="contained"
                target="_blank"
                rel="noopener noreferrer"
                href="/partnermng/add"
              >
                거래처 등록
              </Button>
            </Box>
          )}
          {link && (
            <Box sx={{ order: { xs: 3, sm: 0 }, flexBasis: { xs: '100%', sm: 'auto' }, display: { xs: 'block', sm: 'none' }, mt: 0.5 }}>
              <Button
                size="small"
                component={Link}
                color="warning"
                variant="contained"
                target="_blank"
                rel="noopener noreferrer"
                href="/partnermng/add"
              >
                거래처 등록
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </div>
  );
};
